export const Navbar = () => (
  <header className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10" data-testid="navbar">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-12 lg:px-20 h-16 flex items-center justify-between">
      <a href="/" className="flex items-center gap-3" data-testid="nav-logo">
        <span className="w-2.5 h-2.5 bg-[#FF3B00]" />
        <span className="font-display font-semibold uppercase tracking-widest text-sm">CNCroutersoft</span>
      </a>
      <nav className="hidden md:flex items-center gap-8 font-mono2 text-[11px] uppercase tracking-[0.2em] text-white/50">
        <a href="#features" className="hover:text-[#FF3B00] transition-colors" data-testid="nav-features">Features</a>
        <a href="/forum" className="hover:text-[#FF3B00] transition-colors" data-testid="nav-forum">Forum</a>
        <a href="#requirements" className="hover:text-[#FF3B00] transition-colors" data-testid="nav-requirements">Requirements</a>
        <a href="#setup" className="hover:text-[#FF3B00] transition-colors" data-testid="nav-setup">Setup</a>
      </nav>
      <a href="#download" className="font-mono2 text-[11px] uppercase tracking-[0.2em] px-5 py-2.5 border border-[#FF3B00] text-[#FF3B00] hover:bg-[#FF3B00] hover:text-black transition-colors" data-testid="nav-get-build">
        Get the build
      </a>
    </div>
  </header>
);
